import React from "react";
import ReactDOM from "react-dom";

import { Provider } from "react-redux";
import store from "./store";

import { Router, Route, Switch } from "react-router-dom";
import history from "./history";

import Srp from "./components/search/search";
import CheckoutNew3 from "./components/checkout/checkoutNew3";
import Success from "./components/success/success";
import Login from "./components/login";
//import ManageAccount from "./components/manageAccount";

import "./styles/main.scss";
//import Branch from "./components/branch";

import SearchTourPackage from "./components/search_tour_package";
import Package_checkout from "./components/checkout/package_checkout";
import GuestCancel from "./components/guestCancel/guestCancel";
import GuestCancelConfirm from "./components/guestCancel/guestCancelConfirm";

ReactDOM.render(
  <Provider store={store}>
    <Router history={history}>
      <Switch>
        <Route path="/search_tour_package/" component={SearchTourPackage} />
        <Route path="/package/exp/:token" component={Package_checkout} />
        <Route path="/tour-guest-cancel" component={GuestCancel} />
        <Route path="/tour-guest-cancel-confirm" component={GuestCancelConfirm} />


        {/*         
        <Route path="/co/exp/:token" component={CheckoutNew3} />
        <Route path="/success/:token" component={Success} />
        <Route path="/login/" component={Login} />
        <Route path="/account" component={ManageAccount} />
         */}
      </Switch>
    </Router>
  </Provider>,
  document.getElementById("root")
);

// registerServiceWorker();

// images
// min height
// routing
